const getExamSectionMap = (examSections) => {
  let examSectionsMap = {};
  examSections.forEach((section) => {
    examSectionsMap[section.sectionId] = section;
  });
  return examSectionsMap;
};

export default getExamSectionMap;
